import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	EndorsementsDeleteEndorsementMutation,
	EndorsementsDeleteEndorsementMutationVariables,
} from './deleteEndorsement.graphql';
import { EndorsementsDeleteEndorsement } from './deleteEndorsement.graphql';

export type DeleteEndorsementInput = {
	endorsementId: string;
	petitionId: string;
};

export type DeleteEndorsementResponse = NonNullable<EndorsementsDeleteEndorsementMutation['deleteEndorsement']>;

export async function deleteEndorsement(
	input: DeleteEndorsementInput,
	{ gql: { fetch } }: UtilityContext,
): Promise<DeleteEndorsementResponse> {
	const { data } = await fetch<EndorsementsDeleteEndorsementMutation, EndorsementsDeleteEndorsementMutationVariables>({
		query: EndorsementsDeleteEndorsement,
		variables: { input },
		rejectOnError: true,
	});
	if (!data) throw new Error('Empty data in deleteEndorsement graphQL response');

	return data.deleteEndorsement;
}
